import { ActionIcon, Menu, Text as MantineText } from '@mantine/core';
import { IconCheck } from '@tabler/icons';
import { FC } from 'react';
import { Language } from '../../Service/DocumentT';

const languageOptions: { flag: string; label: string; value: Language }[] = [
  { flag: '🇩🇪', label: 'Deutsch', value: 'german' },
  { flag: '🇬🇧', label: 'Englisch', value: 'english' },
];

const DocumentLanguagePicker: FC<{
  language?: Language | null;
  onLanguageChange?: (language: Language) => void;
}> = ({ language = 'german', onLanguageChange }) => {
  const documentLanguage = language ?? 'german';
  const languageFlag =
    languageOptions.find((option) => option.value === documentLanguage)?.flag ?? languageOptions[0].flag;

  return (
    <Menu shadow="md" width={180} transition="scale-y" position="bottom-end">
      <Menu.Target>
        <ActionIcon
          size={30}
          color="blue"
          variant="transparent"
          disabled={!onLanguageChange}
          title="Dokumentsprache ändern"
          aria-label="Dokumentsprache ändern"
        >
          <MantineText component="span" size="lg" sx={{ lineHeight: 1 }}>
            {languageFlag}
          </MantineText>
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>Dokumentsprache</Menu.Label>
        {languageOptions.map((option) => (
          <Menu.Item
            key={option.value}
            icon={
              <MantineText component="span" size="lg" sx={{ lineHeight: 1 }}>
                {option.flag}
              </MantineText>
            }
            rightSection={option.value === documentLanguage ? <IconCheck size={16} /> : undefined}
            onClick={() => onLanguageChange?.(option.value)}
          >
            {option.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export default DocumentLanguagePicker;
